<template>
  <div class="contact">
    <section class="hero">
      <div class="hero-bg" :style="{ backgroundImage: `url(${hero})` }"></div>
    </section>

    <section class="container main">
      <h1 class="title">联系我们</h1>
      <div class="hours">
        <div>工作时间：</div>
        <div>周一至周日：上午9点至下午6点</div>
        <div>联系地址：广东省罗湖区洪湖路湖景花园湖清阁30D</div>
        <div>联系电话 (同微信)：(+86) 195 3762 1060 / 136 9224 8397</div>
        <div>联系邮箱：services@yoostone.com</div>
        <div>邮政编码：518020</div>
        <div>如果您有任何疑问，我们将竭诚为您服务</div>
      </div>

      <div class="form">
        <ElInput v-model="form.name" placeholder="姓名" />
        <ElInput v-model="form.email" placeholder="邮箱" />
        <ElInput v-model="form.phone" placeholder="联系电话" />
        <ElInput
          v-model="form.msg"
          type="textarea"
          :rows="5"
          placeholder="请输入你的留言"
        />
        <ElButton class="send" @click="submit">发送</ElButton>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { ElMessage } from "element-plus";
import AppFooter from "@/components/AppFooter.vue";
import heroImg from "~/assets/image/1.png";
const hero = heroImg as string;
const form = reactive({ name: "", email: "", phone: "", msg: "" });
const api = useApi();
const submit = async () => {
  const name = String(form.name || "").trim();
  const email = String(form.email || "").trim();
  const phone = String(form.phone || "").trim();
  const msg = String(form.msg || "").trim();
  if (!name || !email || !phone || !msg) {
    ElMessage.error("请填写完整信息");
    return;
  }
  const emailOk = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);
  if (!emailOk) {
    ElMessage.error("邮箱格式不正确");
    return;
  }
  if (msg.length < 5) {
    ElMessage.error("留言内容不少于5个字符");
    return;
  }
  const payload = {
    userName: name,
    email,
    contact: phone,
    content: msg,
  };
  const res = await api.post<any>("/message/addMessage", payload, { loading: true });
  if (res.code == '00000') {
    ElMessage.success("发送成功");
    form.name = "";
    form.email = "";
    form.phone = "";
    form.msg = "";
  } else {
    ElMessage.error((res as any)?.msg || "发送失败");
  }
};
</script>

<style scoped>
.contact {
  font-size: 0.16rem;
}
.container {
  width: 100%;
  padding: 0 0.9rem;
}
.hero {
  height: 5.6rem;
}
.hero-bg {
  height: 100%;
  background-size: cover;
  background-position: center bottom;
}
.main {
  max-width: 12rem;
  margin: 0.8rem auto;
}
.title {
  font-size: 0.3rem;
  margin-bottom: 0.4rem;
  font-weight: 700;
}
.hours {
  color: #444;
  margin-bottom: 0.6rem;
  line-height: 2;
}
.form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.2rem;
}
.form :deep(.el-input__wrapper) {
  height: 0.64rem;
}
.form :deep(.el-input__inner) {
  height: 0.64rem;
  line-height: 0.64rem;
}
.form :deep(textarea.el-textarea__inner) {
  resize: none;
}
.form > :nth-child(3) {
  grid-column: 1 / -1;
}
.form > :nth-child(4) {
  grid-column: 1 / -1;
}
.send {
  width: 1.6rem;
  height: 0.64rem;
  background: #000;
  border-color: #000;
  color: #fff;
}
@media (max-width: 960px) {
  .container {
    padding: 0 0.24rem;
  }
  .form {
    grid-template-columns: 1fr;
  }
}
</style>
